import { log, callAdminAjax, nextFrame, getTemplate, createTranslator } from './utils.js';
import { setFenixBackdrop, setFenixModalContent, openFenixModal, closeFenixModal } from './fenixModal.js';

const $ = window.jQuery;

// Create a translator function for the common module.
const t = createTranslator('common');

export function initCommon() {
    initCommonUI();
}

function initCommonUI() {

    // Common event listeners

    // Checkin button click handler.
    $(document).on('click', '[data-action="checkin"]', async function (event) {
        event.preventDefault();
        const $button = $(this);
        const checkinPostId = $button.data('checkin-post-id') ?? null;
        
        // Disable button.
        $button.prop('disabled', true).addClass('disabled');
        const success = await doCheckin(checkinPostId);
        if(success) {
            $button.addClass('checked-in').prop('disabled', false).removeClass('disabled');
            // Close the modal.
            closeFenixModal();
        } else {
            $button.prop('disabled', false).removeClass('disabled');
        }
    });

    // Checkins button click handler.
    $(document).on('click', '[data-action="showCheckinsPopup"]', function (event) {
        event.preventDefault();
        const $button = $(this);
        const postId = $button.data('checkins-post-id') ?? null;
        const countryName = $button.data('checkins-country-name') ?? null; // Needed for tz.
        if(!postId) {
            log('showCheckinsPopup: Missing post id', postId);
            return false;
        }
        openCheckinsModal(parseInt(postId), countryName);
    });

    // Checkins modal tab click handler.
    $(document).on('click', '[data-action="loadCheckinsModalTab"]', function (event) {
        event.preventDefault();
        const $button = $(this);
        const tabType = $button.data('tab-type') ?? null;
        const tabLoaded = $button.attr('data-loaded') ?? false;
        const postId = $button.closest('#checkinsModalContainer').attr('data-post-id') ?? null;
        const countryName = $button.closest('#checkinsModalContainer').attr('data-country-name') ?? null;
        if(!postId) {
            log('checkinsModalTab: Missing post id', postId);
            return false;
        }
        if(!tabType) {
            log('checkinsModalTab: Missing tab type', tabType);
            return false;
        }
        if(tabLoaded === 'true') {
            return false;
        }
        if(!tabType) {
            log('checkinsModalTab: Missing tab type', tabType);
            return false;
        }
        loadCheckinsModalTab(postId, countryName, tabType);
    });

    $(document).on('click', '[data-action="openSharePostPopup"]', function (event) {
        event.preventDefault();
        const $button = $(this);
        const postId = $button.data('post-id') ?? null;
        const postType = $button.data('post-type') ?? null;
        if(!postId || !postType) {
            log('openSharePostPopup: Missing post id or post type', postId, postType);
            return false;
        }
        showSharePostPopup(postId, postType);
    });

    $(document).on('change', '#credential-sort-stamps-select', function (event) {
        event.preventDefault();
        const $select = $(this);
        const sortBy = $select.val() ?? null;
        if(sortBy === 'date') {
            const url = new URL(window.location.href);
            url.searchParams.set('sort', 'date');
            window.location.href = url.toString();
        } else if(sortBy === 'alphabetical') {
            const url = new URL(window.location.href);
            url.searchParams.set('sort', 'alphabetical');
            window.location.href = url.toString();
        }
    });

    $(document).on('click', '[data-action="showLoginModal"]', function (event) {
        event.preventDefault();
        const $button = $(this);
        alert(t('youMustBeLoggedInToDoThat'));
    });

    // Save post toggle button click handler.
    // data-post-id is optional, and will default to the current post if not provided.
    // However, data-post-id is required to toggle the button state.
    $(document).on('click', '[data-action="savePostToggle"]', async function (event) {
        event.preventDefault();
        const $button = $(this);
        let postId = $button.data('post-id') ?? null;
        if(!postId) {
            postId = window.ironman.postId;
            if(!postId) {
                log('savePostToggle: Missing post id', postId);
                return false;
            }
        }
        
        // Get the save post toggle button.
        const $savePostToggleButton = $(`[data-label="savePostToggleButton"][data-post-id="${postId}"]`);

        if(window.ironman.userData.userSavedPosts.includes(postId)) {
            const success = await doSaveDelete(postId);
            if(success) {
                // Add UNSAVED class to icon.
                $savePostToggleButton.children('i').removeClass().addClass('ci-heart');

                // Update container tooltip if it has one.
                if($savePostToggleButton.parent().data('bs-toggle') === 'tooltip') {
                    const el      = $savePostToggleButton.parent()[0];
                    const tooltip = bootstrap.Tooltip.getInstance(el);
                    tooltip?.setContent({ '.tooltip-inner': t('addToFavoritesTooltipMessage') });
                }
            }
        } else {
            const success = await doSaveAdd(postId);
            if(success) {
                // Add SAVED class to icon.
                $savePostToggleButton.children('i').removeClass().addClass('ci-heart-fill color-red');
                
                // Update container tooltip if it has one.
                if($savePostToggleButton.parent().data('bs-toggle') === 'tooltip') {
                    const el      = $savePostToggleButton.parent()[0];
                    const tooltip = bootstrap.Tooltip.getInstance(el);
                    tooltip?.setContent({ '.tooltip-inner': t('removeFromFavoritesTooltipMessage') });
                }
            }
        }
    });

    $(document).on('click', '[data-action="openArgsModal"]', function (event) {
        event.preventDefault();
        openSimpleModal('Args', 'argsModalTemplate');
    });
}

/**
 * Check in to a place, or listing.
 * @param {number} checkinPostId - The ID of the post to check in to.
 * @param {string} snonce - A custom snonce for the checkin.
 */
async function doCheckin(checkinPostId = null, snonce = null) {
    // Use input vars first, or fallback to current post.
    const payload = {
        target_post_id: checkinPostId,
        post_id: window.ironman.postId,
        snonce: snonce || window.ironman.snonce,
        _ajax_nonce: window.ironman.gnonce
    };
    const response = await callAdminAjax('checkin_add', payload, 'doCheckin', {
        onSuccess: (response) => {
            log('Success:', response);
        },
        onFail: (error) => {
            log('Error:', error);
        }
    }, 'non-blocking', t('savingCheckinSpinnerMessage'));
    if(response.success) {
        return true;
    } else {
        return false;
    }
}

async function doSaveAdd(post_id = null) {
    // Use input vars first, or fallback to current post.
    const payload = {
        post_id: post_id || window.ironman.postId,
        page_post_id: window.ironman.postId,
        snonce: window.ironman.snonce,
        _ajax_nonce: window.ironman.gnonce
    };
    const response = await callAdminAjax('save_add', payload, 'doSaveAdd', null, 'non-blocking', t('savingToFavoritesSpinnerMessage'));
    
    if(response.success) {
        window.ironman.userData.userSavedPosts.push(post_id);
        return true;
    } else {
        return false;
    }
}

export async function doSaveDelete(post_id = null) {
    // Use input vars first, or fallback to current post.
    const payload = {
        post_id: post_id || window.ironman.postId,
        page_post_id: window.ironman.postId,
        snonce: window.ironman.snonce,
        _ajax_nonce: window.ironman.gnonce
    };
    const response = await callAdminAjax('save_delete', payload, 'doSaveDelete', null, 'non-blocking', t('removingFromFavoritesSpinnerMessage'));
    if(response.success) {
        window.ironman.userData.userSavedPosts = window.ironman.userData.userSavedPosts.filter(id => id !== post_id);
        return true;
    } else {
        return false;
    }
}

function doCheckinDelete(checkin_id, post_id, snonce) {
    // Would run from checkins page, so can't depend on any page variables.
    const payload = {
        checkin_id: parseInt(checkin_id),
        post_id: parseInt(post_id),
        snonce: snonce,
        _ajax_nonce: window.ironman.gnonce
    };
    callAdminAjax('checkin_delete', payload, 'doCheckinDelete', {
        onSuccess: (response) => {
            log('Success:', response);
        },
        onFail: (error) => {
            log('Error:', error);
        }
    }, 'non-blocking', t('deletingCheckinSpinnerMessage'));
}

async function openCheckinsModal(postId, countryName = null) {
    log('openCheckinsModal', postId);
    // Make sure the Fenix modal has a backdrop.
    await setFenixBackdrop(true);

    // Update the Fenix modal with the Route Select modal content.
    const modalTitle = t('checkInsModal_title');
    const modalFooter = null;
    const modalDesktopSize = 'sm';
    const modalMobileHeight = 'short';
    const modalDataPurpose = 'checkins'; // To ID this modal content for JS/CSS selectors. This is used to identify the modal content for JS/CSS selectors.
    
    // Load animated bootstrap placeholder for loading.
    setFenixModalContent(modalTitle, getTemplate('loadingPlaceholder'), modalFooter, modalDesktopSize, modalMobileHeight, modalDataPurpose);
    await openFenixModal();
    await nextFrame(); //wait for the next frame to ensure the modal is open before continuing.
    
    let modalBody = getTemplate('checkinsModalTemplate');
    
    // Start customizing the modal body...

    modalBody.attr('data-post-id', postId).attr('data-country-name', countryName);
    // End customizing the modal body...

    // Set the modal content. True means don't change it - for use when the modal is already open.
    setFenixModalContent(true, modalBody, true, true, true, true);
    
    loadCheckinsModalTab(postId, countryName, 'total', true);
}

async function loadCheckinsModalTab(postId, countryName, tabType, fetchCounts = false) {
    log('loadCheckinsModalTab', tabType);

    const singleItemTemplate = getTemplate('checkinsModalSingleItemTemplate');

    // Get checkins data for the post.
    const checkinsResponse = await callAdminAjax('getCheckins', {
        post_id: postId,
        type: tabType,
        country_name: countryName,
        limit: 50,
        offset: 0,
        fetch_counts: fetchCounts ? 'true' : 'false'
    }, 'getCheckins', {
        onSuccess: (response) => {
            log('Success:', response);
        },
        onFail: (error) => {
            log('Error:', error);
            $(`#checkinsModalContainer`).find(`[data-label="checkinsList_${tabType}"]`).html('Error loading checkins.');
            return false;
        }
    }, 'non-blocking', t('fetchingCheckinDataSpinnerMessage'));

    if(checkinsResponse.success) {
        const checkins = checkinsResponse.data.checkins;
        if(checkins.length > 0) {
            let items = [];
            $.each(checkins, function(index, checkin) {
                const item = $(singleItemTemplate).clone();
                item.find('[data-label="userAvatar"]').attr('src', checkin.userData.profilePictureURL);
                item.find('[data-label="userFullName"]').text(checkin.userData.name);
                // item.find('[data-label="userCheckinDate"]').text(checkin.last_checked_at);
                item.attr('href', checkin.userData.profileLink);
                if(checkin.is_friend === "1") {
                    item.find('[data-label="userIsFriend"]').removeClass('d-none');
                }
                items.push(item);
            });
            $(`#checkinsModalContainer`).find(`[data-label="checkinsList_${tabType}"]`).empty().append(items);
        } else {
            $(`#checkinsModalContainer`).find(`[data-label="checkinsList_${tabType}"]`).html(t('noCheckinsYet'));
        }

        // Set data loaded flag
        $(`#checkinsModalContainer`).find(`button[data-action="loadCheckinsModalTab"][data-tab-type="${tabType}"]`).attr('data-loaded', 'true');

        // Set counts
        if(fetchCounts === true && typeof checkinsResponse.data.counts === 'object') {
            $(`#checkinsModalContainer`).find(`[data-label="checkinsCounts_total"]`).text('(' + checkinsResponse.data.counts.total + ')');
            $(`#checkinsModalContainer`).find(`[data-label="checkinsCounts_today"]`).text('(' + checkinsResponse.data.counts.today + ')');
            $(`#checkinsModalContainer`).find(`[data-label="checkinsCounts_ontheway"]`).text('(' + checkinsResponse.data.counts.ontheway + ')');

            // If counts are 0, set data-loaded flag to true and set the placeholder.
            if(parseInt(checkinsResponse.data.counts.today) === 0) {
                $(`#checkinsModalContainer`).find(`button[data-action="loadCheckinsModalTab"][data-tab-type="today"]`).attr('data-loaded', 'true');
                $(`#checkinsModalContainer`).find(`[data-label="checkinsList_today"]`).html(t('noCheckinsYet'));
            }
            if(parseInt(checkinsResponse.data.counts.ontheway) === 0) {
                $(`#checkinsModalContainer`).find(`button[data-action="loadCheckinsModalTab"][data-tab-type="ontheway"]`).attr('data-loaded', 'true');
                $(`#checkinsModalContainer`).find(`[data-label="checkinsList_ontheway"]`).html(t('noCheckinsYet'));
            }
        }
    } else {
        log('Error:', checkinsResponse.data.message);
        $(`#checkinsModalContainer`).find(`[data-label="checkinsList_${tabType}"]`).html(checkinsResponse.data.message);
    }
}

async function showSharePostPopup(postId, postType) {    
    log('showSharePostPopup', postId, postType);
    // Make sure the Fenix modal has a backdrop.
    await setFenixBackdrop(true);

    // Update the Fenix modal with the Route Select modal content.
    const modalTitle = t('sharePostModal_title');
    const modalFooter = null;
    const modalDesktopSize = 'sm';
    const modalMobileHeight = 'short';
    const modalDataPurpose = 'sharePost'; // To ID this modal content for JS/CSS selectors. This is used to identify the modal content for JS/CSS selectors.
    
    // Load animated bootstrap placeholder for loading.
    setFenixModalContent(modalTitle, getTemplate('loadingPlaceholder'), modalFooter, modalDesktopSize, modalMobileHeight, modalDataPurpose);
    await openFenixModal();
    await nextFrame(); //wait for the next frame to ensure the modal is open before continuing.
    
    let modalBody = getTemplate('sharePostModalTemplate');
    
    // Start customizing the modal body...
    
    // End customizing the modal body...

    // Set the modal content. True means don't change it - for use when the modal is already open.
    setFenixModalContent(true, modalBody, true, true, true, true);
}

/**
 * Show an action menu modal.
 * @param {string} title - The title of the modal.
 * @param {Array} actionMenuItems - The action menu items to display in the modal.
 * 
 * Example:
 * showActionMenuModal('Improve this listing', [
 *     {
 *         icon: 'ci-pencil-simple-line',
 *         text: 'Suggest edits',
 *         action: 'suggestEdits'
 *     },
 *     {
 *         icon: 'ci-copy',
 *         text: 'Report duplicate',
 *         action: 'reportDuplicate'
 *     },
 *     {
 *         icon: 'ci-check-circle',
 *         text: 'Claim Listing',
 *         action: 'claimListing'
 *         data: {
 *             parent_post_id: 123
 *         }
 *     },
 *     {
 *         icon: 'ci-check-circle',
 *         text: 'Link Example',
 *         link: 'https://example.com'
 *     }
 * ]);
 */
export async function showActionMenuModal(title, actionMenuItems) {
    
    // Make sure the Fenix modal has a backdrop.
    await setFenixBackdrop(true);

    // Update the Fenix modal with the Route Select modal content.
    const modalTitle = title;
    const modalFooter = null;
    const modalDesktopSize = 'sm';
    const modalMobileHeight = 'short';
    const modalDataPurpose = 'actionMenu'; // To ID this modal content for JS/CSS selectors. This is used to identify the modal content for JS/CSS selectors.
    
    // Load animated bootstrap placeholder for loading.
    setFenixModalContent(modalTitle, getTemplate('loadingPlaceholder'), modalFooter, modalDesktopSize, modalMobileHeight, modalDataPurpose);
    await openFenixModal();
    await nextFrame(); //wait for the next frame to ensure the modal is open before continuing.
    
    let modalBody = getTemplate('actionMenuTemplate');
    const $actionMenuList = modalBody.find('[data-label="actionMenuList"]');
    $actionMenuList.empty();
    // Start customizing the modal body...
    const $actionMenuItemTemplate = getTemplate('actionMenuItemTemplate');
    const actionMenuItemsArray = [];
    actionMenuItems.forEach(item => {
        const $actionMenuItem = $actionMenuItemTemplate.clone(true, true);
        $actionMenuItem.find('[data-label="actionMenuItemIcon"]').addClass(item.icon || 'd-none');
        $actionMenuItem.find('[data-label="actionMenuItemText"]').text(item.text);
        // Top level element is the <a> tag.
        $actionMenuItem.attr('data-action', item.action).attr('alt', item.text);
        if(item.data) {
            $.each(item.data, function(key, value) {
                $actionMenuItem.attr('data-' + key, value);
            });
        }
        if(item.link) {
            $actionMenuItem.attr('href', item.link);
        }
        actionMenuItemsArray.push($actionMenuItem);
    });
    $actionMenuList.append(actionMenuItemsArray);

    // Set the modal content. True means don't change it - for use when the modal is already open.
    setFenixModalContent(true, modalBody, true, true, true, true);
}

// Opens a simple modal with no customization needed.
export async function openSimpleModal(title, bodyTemplate, desktopSize='sm', mobileHeight='short', footerTemplate = null) {
    
    // Make sure the Fenix modal has a backdrop.
    await setFenixBackdrop(true);

    // Update the Fenix modal with the Route Select modal content.
    const modalTitle = title;
    const modalFooter = null; // Can enable this later if needed.
    const modalDesktopSize = desktopSize;
    const modalMobileHeight = mobileHeight;
    const modalDataPurpose = 'simpleModal-' + bodyTemplate; // To ID this modal content for JS/CSS selectors. This is used to identify the modal content for JS/CSS selectors.
    
    // Load animated bootstrap placeholder for loading.
    setFenixModalContent(modalTitle, getTemplate('loadingPlaceholder'), modalFooter, modalDesktopSize, modalMobileHeight, modalDataPurpose);
    await openFenixModal();
    await nextFrame(); //wait for the next frame to ensure the modal is open before continuing.
    
    let modalBody = getTemplate(bodyTemplate);

    // Set the modal content. True means don't change it - for use when the modal is already open.
    setFenixModalContent(true, modalBody, true, true, true, true);
}
